"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Notification = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M15.273 12.366H.727c-.97 0-.97-1.455 0-1.455.804 0 1.455-.651 1.455-1.455V5.82a5.819 5.819 0 1 1 11.636 0v3.637c0 .804.651 1.455 1.455 1.455.97 0 .97 1.455 0 1.455zm-5.386 2.547a2.182 2.182 0 0 1-3.774 0 .727.727 0 0 1 .629-1.093h2.516c.56 0 .91.608.63 1.093z"
}));

var _default = Notification;
exports.default = _default;